import React, { Dispatch, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'react-bootstrap';
import { IDiscoveryPreSetData } from '../dto/IDiscoveryFilter';
import DiscoveryPresetFilterDropdown from './DiscoveryPresetFilterDropdown';

interface IDiscoveryHeaderProps {
    favoritesCount: number;
    goToFavorites: () => void;
    presetOptions: IDiscoveryPreSetData[];
    presetFilterCount: number;
    presetFilterAction: (filterId: number) => void;
    clearPresetFilter: () => void;
    setPresetFilterParams: Dispatch<SetStateAction<{ perPage: number; page: number }>>;
    presetFilterParams: { perPage: number; page: number };
    setSelectedPresetOption: Dispatch<SetStateAction<number | null>>;
    selectedPresetOption: number | null;
}

const DiscoveryHeader = ({
    favoritesCount,
    goToFavorites,
    presetFilterCount,
    clearPresetFilter,
    presetFilterAction,
    presetOptions,
    setPresetFilterParams,
    presetFilterParams,
    selectedPresetOption,
    setSelectedPresetOption,
}: IDiscoveryHeaderProps) => {
    const { t } = useTranslation();

    return (
        <div className="d-md-flex justify-content-between">
            <div>
                <h4 className="mb-0">{t('brand.campaign.discovery.discovery')}</h4>
                <p className="text-muted mb-0">{t('brand.campaign.discovery.find_all')}</p>
            </div>
            <div className="d-flex align-items-center mt-2 mt-md-0">
                <div className="flex-shrink-0" style={{ minWidth: 220 }}>
                <DiscoveryPresetFilterDropdown
                    presetFilterAction={presetFilterAction}
                    presetOptions={presetOptions}
                    count={presetFilterCount}
                    clearPresetFilter={clearPresetFilter}
                    setFilterParams={setPresetFilterParams}
                    filterParams={presetFilterParams}
                    selectedPresetOption={selectedPresetOption}
                    setSelectedPresetOption={setSelectedPresetOption}
                />
                </div>
                <div className="ml-3">
                    <Button onClick={goToFavorites} variant="outline-primary">
                        {t('brand.campaign.discovery.favorite', { nbFavorite: favoritesCount })}
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default React.memo(DiscoveryHeader);
